import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import './App.css';
import App from './App';
import keycloak, { keycloakInitOptions } from './keycloak';

// Loading component shown during Keycloak initialization
const LoadingComponent = () => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{ 
        fontSize: '24px', 
        marginBottom: '20px',
        color: '#333'
      }}>
        Hills Coupon Insights
      </div>
      <div style={{ 
        fontSize: '16px', 
        color: '#666'
      }}>
        Authenticating...
      </div>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={keycloakInitOptions}
      LoadingComponent={LoadingComponent}
      onEvent={(event, error) => {
        if (error) {
          console.error('Keycloak error:', error);
        }
      }}
      onTokens={(tokens) => {
        // Token update handling without debug logging
      }}
    >
      <App />
    </ReactKeycloakProvider>
  </BrowserRouter>
); 